// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`SelectAutocomplete test Match con el snapshot 1`] = `""`;
